import type { AppStore } from "@/store";
import { trackEvent, TrackedEvent } from "@/domains/metrics";
import { SubscriptionPlanKind } from "@/store/subscriptions/types";

export type FloatingAgentProactiveTrialBannerTrackingAction = "view" | "click" | "dismiss";

const getTrackedEventForAction = (
  action: FloatingAgentProactiveTrialBannerTrackingAction
):
  | TrackedEvent.FloatingAgentProactiveTrialBannerView
  | TrackedEvent.FloatingAgentProactiveTrialBannerClicked
  | TrackedEvent.FloatingAgentProactiveTrialBannerDismissed => {
  switch (action) {
    case "view":
      return TrackedEvent.FloatingAgentProactiveTrialBannerView;
    case "click":
      return TrackedEvent.FloatingAgentProactiveTrialBannerClicked;
    case "dismiss":
      return TrackedEvent.FloatingAgentProactiveTrialBannerDismissed;
  }
};

/** Tracks the floating Mem Agent Proactive trial banner from either web or desktop. */
export const trackFloatingAgentProactiveTrialBanner = ({
  action,
  store,
}: {
  action: FloatingAgentProactiveTrialBannerTrackingAction;
  store: AppStore;
}): void => {
  const currentPlanKind =
    store.subscriptions.billingDisplayPlanKind ??
    store.subscriptions.featureAccess?.planKind ??
    SubscriptionPlanKind.UNKNOWN;
  const effectivePlanKind = store.subscriptions.effectiveDisplayPlanKind ?? currentPlanKind;

  trackEvent(getTrackedEventForAction(action), {
    source: "floating_agent_proactive_trial_banner",
    current_plan_kind: currentPlanKind,
    effective_plan_kind: effectivePlanKind,
    target_plan_kind: SubscriptionPlanKind.PROACTIVE,
    is_proactive_trial_eligible: store.subscriptions.isProactiveTrialEligible,
    proactive_trial_banner_is_dismissed:
      store.spaceAccountSettings.memAgent.proactiveTrialBannerIsDismissed,
  });
};
